export const MERGE_VIDEO_SOURCE_TABS = {
  library: {
    value: 'Library',
    isHidden: false,
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
  wheelsTv: {
    value: 'WheelsTV',
    isHidden: false,
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
  lesa: {
    value: 'Lesa',
    isHidden: false,
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
  organizationVideo: {
    value: 'OEM',
    isHidden: true, // hide by default and show if has any organization videos
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
  vinReels: {
    value: 'VINReels',
    isHidden: false,
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
};
